// extracted by mini-css-extract-plugin
export var container = "_ku-0";
export var dotAnimation = "_ku-2";
export var dotsLoading = "_ku-1";